import * as yup from 'yup'

export interface FormValues {
  name: string
  email: string
  phone: string
  comment: string
}

export const schema: FormValues = {
  name: '',
  email: '',
  phone: '',
  comment: ''
}

export const validation = (
  formatMessage: (data: Record<string, string>) => string
) => {
  return (
    yup
      .object()
      .shape({
        name: yup
          .string()
          .required(formatMessage({ id: 'validation.required' })),

        email: yup
          .string()
          .email(formatMessage({ id: 'validation.emailValid' }))
          .required(formatMessage({ id: 'validation.emailValid' })),

        phone: yup
          .string(),

        comment: yup
          .string()
          .required(formatMessage({ id: 'validation.required' }))
      })
  )
}
